import React from 'react';
import '../css/Services.css';

function Services() {
  return (
    <section id="services" class="services-section">
    <h2>Our Services</h2>
    <p>We provide innovative solutions for sustainable pet nutrition.</p>
    <p class="call-to-action">
      Ready to learn more? <a href="#contact">Contact Us</a>
    </p>
  </section>
  
  );
}

export default Services;
